// Recovery After ENT Surgery — structured content

export const RECOVERY = {
  preOp: [
    "Follow fasting instructions exactly, usually no food or drink for 6–8 hours before surgery.",
    "Inform the team about all medications, especially blood thinners, and any allergies.",
    "Stop smoking and alcohol well before surgery to support healing.",
    "Arrange for a responsible adult to accompany you and take you home.",
    "Complete all advised pre-operative tests and the pre-anaesthetic check-up.",
    "Bathe and arrive in clean, comfortable, loose clothing on the day of surgery.",
  ],
  diet: [
    "Start with cool water and clear fluids once cleared by the team.",
    "Progress to soft, bland foods, khichdi, curd, mashed vegetables and soups.",
    "For throat surgery, prefer cool, soothing foods and avoid hot, spicy or hard items.",
    "Stay well hydrated throughout the day to aid healing.",
    "Avoid very hot beverages, carbonated drinks and alcohol during early recovery.",
    "Resume a normal diet gradually as advised by the doctor.",
  ],
  medications: [
    "Take all prescribed antibiotics and pain relief exactly as directed.",
    "Use nasal sprays, drops or saline rinses as instructed for nose and sinus surgery.",
    "Do not stop antibiotics early, even if you feel better.",
    "Avoid self-medicating or taking aspirin unless specifically advised.",
    "Keep the surgical area clean and dry as guided.",
  ],
  timeline: [
    {
      period: "First 24–48 Hours",
      detail:
        "Rest at home, mild pain or congestion is normal. Take medicines on time and keep hydrated. Some blood-tinged discharge can be expected.",
    },
    {
      period: "Days 3–7",
      detail:
        "Swelling and discomfort begin to settle. Light daily activities can usually be resumed. Continue diet and medication advice carefully.",
    },
    {
      period: "Week 2",
      detail:
        "Most patients return to work or school. Packing or dressings, if any, are typically removed. Strenuous activity is still avoided.",
    },
    {
      period: "Weeks 3–6",
      detail:
        "Internal healing progresses well. Follow-up confirms recovery. Hearing, breathing or voice improvement becomes clearly noticeable.",
    },
  ],
  warningSigns: [
    "Heavy or persistent bleeding that does not stop",
    "High fever with chills",
    "Severe pain not relieved by prescribed medication",
    "Sudden increase in swelling, redness or pus-like discharge",
    "Difficulty breathing or swallowing",
    "Persistent dizziness or new hearing loss after ear surgery",
  ],
  activityRestrictions: [
    "Avoid heavy lifting and strenuous exercise for 2–3 weeks.",
    "Avoid swimming and keep ears dry after ear surgery until cleared.",
    "Avoid forceful nose-blowing after nasal or sinus surgery.",
    "Avoid air travel after certain ear surgeries until advised.",
    "Avoid dusty, smoky or polluted environments during early healing.",
    "Take adequate rest and avoid straining, especially in the first week.",
  ],
  followUp:
    "Attending your follow-up appointments is essential. These visits allow Dr. Sanjay Teza to remove any packing or dressings, monitor healing, confirm a successful outcome and guide your safe return to normal life. Never skip a scheduled review, even if you feel completely well.",
};
